import type { IdType } from '@servicetitan/data-query';

export const getSimpleValue = (item: any): IdType => {
    if (item === null) {
        return item;
    }

    if (typeof item === 'object' || typeof item === 'function') {
        return `${item}`;
    }

    return item;
};
